export const environment = {
    production: true,
    authUrl: 'https://be-dev.audacity.lcgtech.pt/',
    apiUrl: 'https://be-bo-dev.audacity.lcgtech.pt/',
    // authUrl: 'http://localhost:8080/',
    // apiUrl: 'http://localhost:9001/',
};
